import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import { listarPermisos, listarRolesAdmin } from "../services/roles-service";

/**
 * Listado de roles (sistema + personalizados) · lista corta sin paginar
 * (mismo criterio que los niveles de autorización y overrides del mock SAT).
 */
export const rolesAdminQueryOptions = queryOptions({
  queryKey: qk.adminRoles,
  queryFn: listarRolesAdmin,
});

export function useRolesAdmin() {
  return useSuspenseQuery(rolesAdminQueryOptions);
}

/** Catálogo de permisos (estable · definido en código). */
export const permisosCatalogoQueryOptions = queryOptions({
  queryKey: qk.adminPermisos,
  queryFn: listarPermisos,
  staleTime: 10 * 60 * 1000,
});

export function usePermisosCatalogo() {
  return useSuspenseQuery(permisosCatalogoQueryOptions);
}
